import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineThickness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLineThickness"><Path d="M20 5V6.5H4V5H20Z" fill="currentColor"/><Path d="M20 15.5V19H4V15.5H20Z" fill="currentColor"/><Path d="M20 9.75V12.25H4V9.75H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineThickness;
